import { render, staticRenderFns } from "./rms-objects-service-tab.vue?vue&type=template&id=45e34834&scoped=true"
import script from "./rms-objects-service-tab.vue?vue&type=script&lang=js"
export * from "./rms-objects-service-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e34834",
  null
  
)

export default component.exports